export const TermType = {
  USE: '이용약관',
  TRAVEL: '여행약관',
  INSURANCE: '여행보험약관',
  SAFETY: '해외여행안전정보',
  PRIVACY: '개인정보 처리방침',
} as const;

export type TermType = keyof typeof TermType;
